import { DOCUMENT, Directive, inject } from '@angular/core';

import { OfferButtonComponentBase } from './offer-button-component-base';

/**
 * @stable
 */
@Directive({
    standalone: true,
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[data-offer-id],[data-campaign-id]',
})
export class OfferButtonBehaviorDirective extends OfferButtonComponentBase {
    private readonly _doc = inject(DOCUMENT);

    constructor() {
        super();
        this.doc = this._doc;
    }
}
